import React from "react";

const YurtdisiOrgHero = () => {
  return (
    <div className="">
      <section className="">
        <div className="py-12 bg-white ">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="font-heading mb-4 bg-orange-100 px-4 py-2 rounded-lg md:w-64 md:mx-auto text-xs font-semibold tracking-widest text-black uppercase title-font">
                Neden Bizi Seçmelisiniz?
              </h2>
              <p className="font-heading mt-2 text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl">
                Yurt Dışı Organizasyonlar
              </p>
              <p className="mt-4 max-w-2xl text-lg text-gray-500 lg:mx-auto">
                Kişisel ya da grup olarak aklınızdan geçirdiğiniz her türlü
                organizasyonda biz yanınızdayız. Dünyanın dört bir yanını
                kapsayan lokasyon bilgimiz ve her türden toplantıların yönetimi
                konusundaki deneyimimizle sizinleyiz. Boyutu ve kişi sayısı hiç
                önemli değil.Yurt dışında katılmak ya da düzenlemek istediğiniz
                aktivitelerinizi planlıyor ve uyguluyoruz.
              </p>
            </div>
            <div className="mt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/451393/tour.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Yurt Dışı Teşvik & Bayi Gezileri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    Günümüzde aynı kategorideki ürünlerde kalite ve özellik
                    açısından benzerlikler bulunuyor. Satışları arttırmak sadece
                    ürünün özellikleri ile değil aynı zamanda o ürünü satan
                    kişinin ürüne hakimiyeti ve motivasyonuyla da ilişkili.{" "}
                    <br /> Bu bilinen gerçekten yola çıkarak; <br /> Satış
                    ekiplerini hem eğitip hem de motive etmenin en sağlıklı
                    yöntemi teşvik ve bayi gezileri. Bu tür geziler sayesinde
                    müşteri memnuniyetindeki artışın ciddi oranda satışlara da
                    yansıdığını gözlemliyoruz.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/375050/product-warranty-term.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Ürün Lansmanları
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Ürün ve hizmetlerinizin piyasayla buluştuğu ilk an, edindiği
                    ilk intiba en iyi imajın en doğru kitleyle buluşması ile
                    sağlanıyor. İyi planlanmış bir ürün lansmanıyla çıkış
                    yaptığınızda temas ettiğiniz kitlenin dikkatini çekiyor,
                    kendi kulvarınızda yankı uyandırıyorsunuz. Artık
                    reklamlarınız değil, markanızı kendi isteğiyle savunan
                    avukatlarınız her yerde sizi konuşur hale geliyor. Pazarın
                    yıldızı olmanın ilk adımı işte bu güçlü lansmanlarla
                    atılıyor.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/24954/concert.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Konser Organizasyonları
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Jojo Turizm, dünyanın herhangi bir yerinde misafirlerine,
                    oranın yerlisi olmanın avantajlarını yaşatıyor. Konser,
                    tiyatro, festival fark etmeksizin oralı olmanın rahatlığını
                    sunuyor. Kendi mahallenizdeki etkinliğe katılır gibi kolay
                    gidip yerleşiyorsunuz istediğiniz koltuğa. Evden ilk
                    çıktığınız andan eve döndüğünüz zamana kadar her metreyi
                    beraber katediyoruz.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/55530/protest.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Spor Organizasyonları
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Olimpiyatlar mı yaklaşıyor? Yoksa futbol tarihine geçecek
                    bir maç mı? Belki de bir tenis turnuvası gündemde ya da
                    dünyanın en ünlü denizcileri yelkenlerini fora etmek üzere.
                    Dünya çapında konuşulan spor olaylarının bir köşesinde yer
                    almak herkesin hayali. Çalışanlarınızın veya
                    müşterilerinizin hayalini gerçekleştirmek de bizim
                    hayalimiz.
                  </dd>
                </div>
              </dl>
            </div>
            <div className="mt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/533057/camera-alt-1.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Basın Gezileri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Müşterilerimiz için basın gezilerinin önemini biliyoruz.
                    Yapılacak gezinin vermesi istenen mesaja, katılacak basın
                    mensuplarının profiline en uygun önerileri getirerek işe
                    başlıyoruz. Basın mensuplarının ulaşımı, konaklaması,
                    yapılan aktivite ile ilgili en güzel görüntü ve bilgileri
                    nasıl elde edecekleri gibi detayları müşterilerimizle
                    planlıyoruz. Basınla paylaşmak istediğiniz, ister
                    yurtdışında bir üretim merkezi ziyareti ister sosyal bir
                    etkinlik olsun, yıllar boyu oluşturduğumuz tecrübemiz,
                    yurtdışı ortaklığımız ve marka bilinirliliğimizle
                    yanınızdayız.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/94043/fair-stand.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Fuar Hizmetleri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Günümüzde toplandığımız, çeşitli alışverişlerde bulunduğumuz
                    pazarlar çok ileri boyutlarda. Ancak hala fiziksel olarak
                    bir araya geldiğimiz, bölümler arasında dolaşıp fikirler
                    edindiğimiz bir kent meydanı söz konusu: Fuarlar, yıl
                    boyunca katettiğiniz her mesafenin ötesinde, birçok farklı
                    ilişki türünün geliştiği en önemli yerler arasında. Dost
                    firmalar edinmekten rakipleri alt etmeye, olumsuz fikirleri
                    silmekten sesinizi en yüksek tondan duyurmaya kadar uzunca
                    bir listenin gerçekleştirilebileceği platformlardır.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/524674/letter.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Açılışlar-Davetler
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Ülkenizden uzakta kurumunuza ve amacınıza yakışan davetler
                    ve açılışlar, global bir seyahat acentesiyle evinizdeki
                    kadar görkemli ve rahat geçebilir. Firmanızdaki kurumsal
                    iletişim departmanı ile yakın çalışmalarımız sonucunda,
                    akıllı manevralarla bu tür aktivitelerinize en iyi şekilde
                    gerçekleştirildi notu düşebilirsiniz.
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>
      <>
        {/* Container for demo purpose */}
        <div className="container my-24 mx-auto md:px-6">
          {/* Section: Design Block */}
          <section className="mb-32 m-10">
            {/* Comment */}
            <div className="mb-12 flex flex-wrap md:mb-0">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://images.pexels.com/photos/325193/pexels-photo-325193.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="mb-3 text-2xl font-semibold">
                  Yurt dışı Toplantı, Kongre Ve Seminer Hizmetleri
                </p>
                <p>
                  Jojo Turizm’in yalnızca kongre hizmetlerine odaklanmış
                  deneyimli kadrosu, Türkiye’nin önde gelen firmalarının yurt
                  dışı kongrelere yıllardır eksiksiz bir şekilde katılmasını
                  sağlıyor.
                </p>
              </div>
            </div>
            <div className="mb-12 flex flex-wrap md:mb-0">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://images.pexels.com/photos/17455630/pexels-photo-17455630/free-photo-of-sokak-arac-luks-vip.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="mb-1 text-2xl font-semibold">Transferler</p>
                <ul>
                  <li>
                    Kişi sayısına uygun, konforlu, temiz ve yeni model araçlarla
                    ulaşım
                  </li>
                  <li>Bagaj taşıma ve koordinasyonu hizmeti</li>
                  <li>Lunch box servisi</li>
                </ul>
              </div>
            </div>
            {/* Comment */}
            <div className="mb-12 flex flex-wrap md:mb-0">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://images.pexels.com/photos/97083/pexels-photo-97083.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="mb-12 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="mb-1 text-2xl font-semibold">
                  Otel Rezervasyonları
                </p>
                <ul className="">
                  <li>Bütçe ve kriterlere yönelik konaklama alternatifleri</li>
                  <li>Fiyat konusunda bütçenize uyum</li>
                  <li>Rezervasyon işlemlerini zamanında tamamlamak</li>
                </ul>
              </div>
            </div>
            {/* Comment */}
            <div className="flex flex-wrap">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://images.pexels.com/photos/20235440/pexels-photo-20235440/free-photo-of-siyah-ve-beyaz-kent-sehir-fransa.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="text-xl font-semibold">SOSYAL PROGRAMLAR</p>
                <ul>
                  <li>Yemek ve gala organizasyonları</li>
                  <li>
                    Menü alternatiflerinin belirlenmesi, doğru menü seçimi için
                    yönlendirmeler
                  </li>
                  <li>Oturma düzeni ve ekstra ödemelerin kontrolü</li>
                  <li>
                    Sanatçı / sunucu temini ve ilgili teknik ekipmanların
                    koordinasyonu
                  </li>
                </ul>
                <p className="text-xl font-semibold mt-2">
                  REHBER ORGANİZASYONU
                </p>
                <ul>
                  <li>
                    Destinasyon ve grup deneyimi üst düzeyde profesyonel
                    rehberlerle iş birliği
                  </li>
                  <li>Firma koordinasyonunun sağlanması ve bilgilendirmeler</li>
                </ul>
                <p className="text-xl font-semibold mt-1">KONGRE KAYITLARI</p>
                <ul>
                  <li>Kişilere ve gruplara yönelik kongre kayıt işlemleri</li>
                  <li>
                    Kongre düzenleyici kurumlar ile gerekli temasların kurulması
                  </li>
                  <li>
                    Dolayısıyla kongre kayıtlarınızın en ekonomik bütçe ile
                    zamanında tamamlanması
                  </li>
                </ul>
              </div>
            </div>
          </section>
          {/* Section: Design Block */}
        </div>
        {/* Container for demo purpose */}
      </>
    </div>
  );
};

export default YurtdisiOrgHero;
